import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-689f9918"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "aviso-app-modal__wrap"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "aviso-app-modal__spacer",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = { class: "aviso-app-modal__card" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "aviso-app-modal__title"
}
const _hoisted_6 = { class: "aviso-app-modal__text" }
const _hoisted_7 = {
  key: 3,
  class: "aviso-app-modal__buttons"
}
const _hoisted_8 = {
  key: 4,
  class: "aviso-app-modal__buttons"
}
const _hoisted_9 = {
  key: 5,
  class: "aviso-app-modal__buttons"
}
const _hoisted_10 = {
  key: 6,
  class: "aviso-app-modal__snooze"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "aviso-app-modal__spacer",
  "aria-hidden": "true"
}, null, -1))

import { computed, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { IonButton, IonModal, IonTextarea } from '@ionic/vue';
import tools from '@/composables/tools';
import { useAvisoApp } from '@/composables/useAvisoApp';
import type { AvisoAppBoton } from '@/interfaces/AvisoApp';


export default /*#__PURE__*/_defineComponent({
  __name: 'AvisoAppModal',
  setup(__props) {

const router = useRouter();
const { aviso, isOpen, loading, enviarRespuesta, recordarMasTarde } = useAvisoApp();
const textoLibre = ref('');

function haySesion(): boolean {
  return !!localStorage.getItem('token');
}

const modalAbierto = computed(
  () => haySesion() && isOpen.value && aviso.value !== null
);

const backdropDismiss = computed(() => aviso.value?.backdrop_dismiss ?? false);

watch(modalAbierto, (open) => {
  if (open) {
    textoLibre.value = '';
  }
});

function onPresent(): void {
  if (!aviso.value) {
    return;
  }
  const titulo = aviso.value.titulo?.trim();
  tools().setLog(
    `Se mostró el aviso app #${aviso.value.id}${titulo ? ` (${titulo})` : ''}`
  );
}

function navigateUrl(url: string | null): void {
  if (!url || url.trim() === '') {
    return;
  }
  const trimmed = url.trim();
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    window.open(trimmed, '_blank', 'noopener,noreferrer');
    return;
  }
  const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  void router.push(path);
}

async function onBoton(boton: AvisoAppBoton): Promise<void> {
  const ok = await enviarRespuesta({ boton: boton.indice });
  if (!ok) {
    tools().toast('No se pudo registrar tu respuesta. Inténtalo de nuevo.', 'danger');
    return;
  }
  navigateUrl(boton.url);
}

async function onEnviarTexto(): Promise<void> {
  const texto = textoLibre.value.trim();
  if (aviso.value?.input_obligatorio && texto === '') {
    tools().toast('Debes escribir algo antes de enviar.', 'warning');
    return;
  }
  const ok = await enviarRespuesta({ texto });
  if (!ok) {
    tools().toast('No se pudo enviar tu respuesta. Inténtalo de nuevo.', 'danger');
  }
}

async function onCerrarSoloLectura(): Promise<void> {
  const ok = await enviarRespuesta({});
  if (!ok) {
    tools().toast('No se pudo cerrar el aviso. Inténtalo de nuevo.', 'danger');
  }
}

async function onRecordarMasTarde(): Promise<void> {
  const ok = await recordarMasTarde();
  if (!ok) {
    tools().toast('No se pudo posponer el aviso. Inténtalo de nuevo.', 'danger');
    return;
  }
  const minutos = aviso.value?.recordar_mas_tarde_minutos ?? 180;
  tools().toast(`Te volvemos a preguntar dentro de ${etiquetaIntervalo(minutos)}.`, 'success', 4000);
}

function etiquetaIntervalo(minutos: number): string {
  if (minutos % 60 === 0) {
    const h = minutos / 60;
    return h === 1 ? '1 hora' : `${h} horas`;
  }
  if (minutos < 60) {
    return minutos === 1 ? '1 minuto' : `${minutos} minutos`;
  }
  const h = Math.floor(minutos / 60);
  const rest = minutos % 60;
  return `${h} h ${rest} min`;
}

async function onDismiss(): Promise<void> {
  if (!aviso.value?.backdrop_dismiss) {
    return;
  }
  await enviarRespuesta({});
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonModal), {
    "is-open": modalAbierto.value,
    "backdrop-dismiss": backdropDismiss.value,
    class: "aviso-app-modal",
    onDidPresent: onPresent,
    onDidDismiss: onDismiss
  }, {
    default: _withCtx(() => [
      (_unref(aviso))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              (_unref(aviso).icono_url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(aviso).icono_url,
                    alt: "",
                    class: "aviso-app-modal__icon"
                  }, null, 8, _hoisted_4))
                : _createCommentVNode("", true),
              (_unref(aviso).titulo)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_unref(aviso).titulo), 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(aviso).texto), 1),
              (_unref(aviso).modo === 'texto_libre')
                ? (_openBlock(), _createBlock(_unref(IonTextarea), {
                    key: 2,
                    modelValue: textoLibre.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textoLibre).value = $event)),
                    class: "aviso-app-modal__input",
                    placeholder: _unref(aviso).input_placeholder || 'Escribe aquí...',
                    rows: 4,
                    "auto-grow": ""
                  }, null, 8, ["modelValue", "placeholder"]))
                : _createCommentVNode("", true),
              (_unref(aviso).modo === 'botones')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aviso).botones, (boton) => {
                      return (_openBlock(), _createBlock(_unref(IonButton), {
                        key: boton.indice,
                        expand: "block",
                        disabled: _unref(loading),
                        onClick: ($event: any) => (onBoton(boton))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(boton.texto), 1)
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onClick"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_unref(aviso).modo === 'texto_libre')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_unref(IonButton), {
                      expand: "block",
                      disabled: _unref(loading),
                      onClick: onEnviarTexto
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Enviar ")
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]))
                : _createCommentVNode("", true),
              (_unref(aviso).modo === 'solo_lectura')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_unref(IonButton), {
                      expand: "block",
                      disabled: _unref(loading),
                      onClick: onCerrarSoloLectura
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Entendido ")
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]))
                : _createCommentVNode("", true),
              (_unref(aviso).mostrar_te_respondo_despues)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_unref(IonButton), {
                      expand: "block",
                      fill: "clear",
                      size: "small",
                      class: "aviso-app-modal__snooze-btn",
                      disabled: _unref(loading),
                      onClick: onRecordarMasTarde
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(aviso).te_respondo_despues_texto), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_11
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["is-open", "backdrop-dismiss"]))
}
}

})